module.exports = __webpack_public_path__ + "static/media/rsz_landing_page.81eeb4a8.png";